module.exports = __webpack_public_path__ + "img/avatar7.546e70bf.png";